import { api } from '@/core/api/';
const apiUrl = 'api/digitizedfile';

export default {
  getAcademicyears() {
    return api.get(`${apiUrl}/academicyears`);
  },
  search(params) {
    return api.get(`${apiUrl}/search`, { params });
  },
};
